const CHART_PNG_BASE_PATH = "/files/png";
const TOPIC_PDF_BASE_PATH = "/files/pdf";

const triggerDownload = (path: string, filename: string) => {
	const link = document.createElement("a");
	link.href = path;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	link.remove();
};

export const downloadChartPng = (filename: string) => triggerDownload(`${CHART_PNG_BASE_PATH}/${filename}`, filename);

export const downloadTopicPdf = (filename: string) => triggerDownload(`${TOPIC_PDF_BASE_PATH}/${filename}`, filename);
